import type { SVGProps } from 'react';

export default function SvgGoogleDrive(
  props: SVGProps<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={19}
      fill="none"
      {...props}
    >
      <g clipPath="url(#google-drive_svg__a)">
        <path
          fill="#0066DA"
          d="m1.663 16.284.97 1.62c.202.34.492.609.832.804L6.93 12.91H0c0 .378.1.755.302 1.096z"
        />
        <path
          fill="#00AC47"
          d="M11 6.09 7.535.291c-.34.195-.63.463-.832.804l-6.4 10.718A2.15 2.15 0 0 0 0 12.91h6.93z"
        />
        <path
          fill="#EA4335"
          d="M18.535 18.708c.34-.195.63-.463.831-.804l.404-.67 1.928-3.228A2.15 2.15 0 0 0 22 12.91h-6.93l1.474 2.801z"
        />
        <path
          fill="#00832D"
          d="M11 6.09 14.465.292A2.3 2.3 0 0 0 13.331 0H8.67c-.403 0-.794.11-1.134.292z"
        />
        <path
          fill="#2684FC"
          d="M15.07 12.91H6.93l-3.465 5.798c.34.195.73.292 1.134.292H17.4c.403 0 .794-.11 1.134-.292z"
        />
        <path
          fill="#FFBA00"
          d="m18.497 6.455-3.2-5.36a2.25 2.25 0 0 0-.832-.803L11 6.089l4.07 6.82h6.917c0-.377-.1-.754-.302-1.095z"
        />
      </g>
      <defs>
        <clipPath id="google-drive_svg__a">
          <path fill="#fff" d="M0 0h22v19H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
